import React, { useEffect, useMemo, useState } from "react";
import {
  faDumpsterFire,
  faHammer,
  faShieldCheck,
} from "@fortawesome/pro-light-svg-icons";
import { SimpleGrid, Text } from "@mantine/core";

import { useBasePath, useOrg } from "@hooks";

import { fetchDemoDeploymentSummaryStats } from "@pages/overview/api";
import { HeaderCard } from "@pages/overview/components/HeaderCard";
import { DeploymentSummaryStats, WidgetInterface } from "@pages/overview/types";

import { useDeploymentSummaryStats } from "../hooks";

export const OverviewHeader: React.FC<WidgetInterface> = ({
  hasProjects,
  reposFilter,
}) => {
  const [error, setError] = useState(false);
  const org = useOrg();
  const basePath = useBasePath();
  const { data: deploymentSummaryStats } =
    useDeploymentSummaryStats(reposFilter);
  const [demoStats, setDemoStats] = useState<DeploymentSummaryStats>();
  const stats = useMemo(
    () => (hasProjects ? deploymentSummaryStats : demoStats),
    [deploymentSummaryStats, demoStats, hasProjects]
  );

  useEffect(() => {
    if (hasProjects || !org) return;
    fetchDemoDeploymentSummaryStats(org.id)
      .then((resp) => setDemoStats(resp))
      .catch(() => setError(true));
  }, [org, hasProjects]);

  if (error) {
    return <Text color="red.8">Failed to load data</Text>;
  }

  return (
    <SimpleGrid cols={3}>
      <HeaderCard
        title="Open findings"
        current={stats?.open_issues_count}
        diff={stats?.open_issues_delta}
        icon={faHammer}
        href={`${basePath}/findings`}
      />
      <HeaderCard
        title="High severity"
        current={stats?.severity_high_count}
        diff={stats?.severity_high_delta}
        icon={faDumpsterFire}
        href={`${basePath}/findings?severity=2`}
      />
      <HeaderCard
        title="Comment fix rate"
        current={stats?.pr_fix_rate}
        diff={stats?.pr_fix_rate_delta}
        icon={faShieldCheck}
        percent
        highIsGood
        blurred={!hasProjects}
      />
    </SimpleGrid>
  );
};
